import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { Box } from "@mui/material";
import TkStrpper from "../../components/atoms/TkStepper";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import TkDialog from "../../components/atoms/TkDialog";
import { fakeTableList, schema, showFakeTableList, stepperData } from "./parts";
import { httpAPI_INQ005, httpAPI_INQ006 } from "./api/request";
import "./_style.scss";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { TkGetCode } from "../../utils/TkGetCode";
import { Prefectures } from "../../assets/data/Constants";
import { BusinessContext } from "../../context/businessContext";
import { changeZipcodeFormat } from "../../utils/useTools";
import _ from "lodash";
/**
 * SCRC070206 原簿閲覧請求
 * @returns JSX.Element (SCR0260)_SCRC070206_原簿閲覧請求
 */
const SCRC070206: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state;
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const [stateInfoList, setStateInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [showTableList, setShowTableList] = useState(showFakeTableList);
  const [latestApplyStatus, setLatestApplyStatus] = useState<any>("");
  const [openKikoDialog, setOpenKikoDialog] = useState(false);
  const [openNormalDialog, setOpenNormalDialog] = useState(false);
  const [inputData, setInputData] = useState({} as any);
  const [documentSelectionValue, setDocumentSelectionValue] = useState<any>("");
  const [formSchema, setFormSchema] = useState(schema);
  const [resData, setResData] = useState<any>();
  const [activeStep, setActiveStep] = useState(0);

  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const isTaiSyokuSha =
    state.authInfo?.userType === authorityUserType.userTypeNumber.TAISYOKUSYA;
  const contractorNo = isKiko
    ? businessState.common?.contractorNo!
    : state.authInfo?.contractorNo!;

  const handleInit = async () => {
    try {
      const res = await httpAPI_INQ006({
        applyId: locationState?.applyId!,
      });
      if (res.resultCd === "I0000") {
        setResData(res);
        const canInputItem = !(
          res.latestApplyStatus === "16" || res.latestApplyStatus === "00"
        );

        if (canInputItem) {
          setActiveStep(1);
        } else {
          setActiveStep(0);
        }

        // 内容入力
        let resArr = stateFakeTableList.current;
        // 共済契約者名
        let contractorName = resArr.find(
          (item) => item.keyword === "contractorName"
        )!;
        contractorName.setDefaultValue = res?.applyCorpName;
        contractorName.disabled = canInputItem;
        // 施設名
        let facilityName = resArr.find(
          (item) => item.keyword === "facilityName"
        )!;
        facilityName.setDefaultValue = res?.applyFacilityName;
        facilityName.disabled = canInputItem;
        // 職員氏名
        let staffName = resArr.find((item) => item.keyword === "staffName")!;
        staffName.setDefaultValue = res?.applyStaffName;
        staffName.disabled = canInputItem;
        // 職員生年月日
        let staffBirthday = resArr.find(
          (item) => item.keyword === "staffBirthday"
        )!;
        staffBirthday.setDefaultValue = res?.applyStaffBirthday;
        staffBirthday.disabled = canInputItem;
        // 確認する書類の選択
        let documentSelection = resArr.find(
          (item) => item.keyword === "documentSelection"
        )!;
        documentSelection.onGetValue = (value: any) => {
          setDocumentSelectionValue(value);
        };
        documentSelection.setDefaultValue = res.identificationDocsKind;
        documentSelection.disabled = canInputItem;
        setDocumentSelectionValue(res.identificationDocsKind);

        // 表示用
        let resShowArr = showFakeTableList;
        // 契約者名
        let showcontractorName = resShowArr.find(
          (item) => item.keyword === "contractorName"
        )!;
        showcontractorName.text = res?.corpName;
        // 契約者住所
        let showContractorAddress = resShowArr.find(
          (item) => item.keyword === "contractoraddress"
        )!;
        showContractorAddress.text = `〒${changeZipcodeFormat(
          res?.cozipcode
        )} ${TkGetCode(Prefectures, res?.coprefectureCd)}${res?.coaddressCity}${
          res?.coaddressOthers
        }`;
        // 施設名
        let showfacilityName = resShowArr.find(
          (item) => item.keyword === "facilityName"
        )!;
        showfacilityName.text = res?.facilityName;
        // 職員名
        let showstaffName = resShowArr.find(
          (item) => item.keyword === "staffName"
        )!;
        showstaffName.text = res?.staffNameKanji;
        // 職員生年月日
        let showstaffBirthday = resShowArr.find(
          (item) => item.keyword === "staffBirthday"
        )!;
        showstaffBirthday.text = res?.birthday;
        // 被共済職員期間
        let showPremiumEnroll = resShowArr.find(
          (item) => item.keyword === "staffperiod"
        )!;
        showPremiumEnroll.text = `${res?.premiumEnrollYear ?? 0}年${
          res?.premiumEnrollMonth ?? 0
        }ヶ月`;

        setLatestApplyStatus(res?.latestApplyStatus);
        setStateInfoList([...resArr]);
        setShowTableList([...resShowArr]);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        return;
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let fileDisabled = !(
      resData?.latestApplyStatus === "00" || resData?.latestApplyStatus === "16"
    );
    let newStateInfoList = stateFakeTableList.current;
    let newSchema = formSchema;
    let personalNumberVerification = newStateInfoList.find(
      (item) => item.keyword === "personalNumberVerification"
    )!;
    let personalNumberFile = resData?.formList?.find(
      (item: {
        serialNo?: number;
        facilityNo?: string;
        staffNo?: string;
        formKbn?: string;
        formClass?: string;
        formName?: string;
        fileBase64?: string;
      }) => item.formClass === "27"
    )!;
    let documentConfirmation = newStateInfoList.find(
      (item) => item.keyword === "documentConfirmation"
    )!;
    let documentConfirmationFile = resData?.formList?.find(
      (item: {
        serialNo?: number;
        facilityNo?: string;
        staffNo?: string;
        formKbn?: string;
        formClass?: string;
        formName?: string;
        fileBase64?: string;
      }) => item.formClass === "23"
    )!;

    let documentConfirmation2 = newStateInfoList.find(
      (item) => item.keyword === "documentConfirmation2"
    )!;
    let documentConfirmationFile2 = resData?.formList?.find(
      (item: {
        serialNo?: number;
        facilityNo?: string;
        staffNo?: string;
        formKbn?: string;
        formClass?: string;
        formName?: string;
        fileBase64?: string;
      }) =>
        item.formClass === "23" &&
        item.serialNo !== documentConfirmationFile.serialNo
    )!;
    let documentConfirmationFront = newStateInfoList.find(
      (item) => item.keyword === "documentConfirmationFront"
    )!;
    let documentFrontFile = resData?.formList?.find(
      (item: {
        serialNo?: number;
        facilityNo?: string;
        staffNo?: string;
        formKbn?: string;
        formClass?: string;
        formName?: string;
        fileBase64?: string;
      }) => item.formClass === "24"
    )!;
    let documentConfirmationBack = newStateInfoList.find(
      (item) => item.keyword === "documentConfirmationBack"
    )!;
    let documentBackFile = resData?.formList?.find(
      (item: {
        serialNo?: number;
        facilityNo?: string;
        staffNo?: string;
        formKbn?: string;
        formClass?: string;
        formName?: string;
        fileBase64?: string;
      }) => item.formClass === "25"
    )!;
    if (documentSelectionValue === "2" || documentSelectionValue === "4") {
      personalNumberVerification.showLine = true;
      personalNumberVerification.disabled = fileDisabled;
      !!personalNumberFile &&
        (personalNumberVerification.setDefaultValue = [
          {
            formName: personalNumberFile?.formName!,
            fileBase64: personalNumberFile?.fileBase64!,
          },
        ]);
      documentConfirmation.showLine = false;
      documentConfirmation2.showLine = false;
      documentConfirmationFront.showLine = true;
      documentConfirmationFront.disabled = fileDisabled;
      !!documentFrontFile &&
        (documentConfirmationFront.setDefaultValue = [
          {
            formName: documentFrontFile?.formName!,
            fileBase64: documentFrontFile?.fileBase64!,
          },
        ]);
      documentConfirmationBack.showLine = true;
      documentConfirmationBack.disabled = fileDisabled;
      !!documentBackFile &&
        (documentConfirmationBack.setDefaultValue = [
          {
            formName: documentBackFile?.formName!,
            fileBase64: documentBackFile?.fileBase64!,
          },
        ]);
    } else if (documentSelectionValue === "1") {
      personalNumberVerification.showLine = true;
      personalNumberVerification.disabled = fileDisabled;
      !!personalNumberFile &&
        (personalNumberVerification.setDefaultValue = [
          {
            formName: personalNumberFile?.formName!,
            fileBase64: personalNumberFile?.fileBase64!,
          },
        ]);
      documentConfirmation.showLine = true;
      documentConfirmation.disabled = fileDisabled;
      !!documentConfirmationFile &&
        (documentConfirmation.setDefaultValue = [
          {
            formName: documentConfirmationFile?.formName!,
            fileBase64: documentConfirmationFile?.fileBase64!,
          },
        ]);
      documentConfirmation2.showLine = false;
      documentConfirmationFront.showLine = false;
      documentConfirmationBack.showLine = false;
    } else if (
      documentSelectionValue === "3" ||
      documentSelectionValue === "5"
    ) {
      personalNumberVerification.showLine = true;
      personalNumberVerification.disabled = fileDisabled;
      !!personalNumberFile &&
        (personalNumberVerification.setDefaultValue = [
          {
            formName: personalNumberFile?.formName!,
            fileBase64: personalNumberFile?.fileBase64!,
          },
        ]);
      documentConfirmation.showLine = true;
      documentConfirmation.disabled = fileDisabled;
      !!documentConfirmationFile &&
        (documentConfirmation.setDefaultValue = [
          {
            formName: documentConfirmationFile?.formName!,
            fileBase64: documentConfirmationFile?.fileBase64!,
          },
        ]);
      documentConfirmation2.showLine = true;
      documentConfirmation2.disabled = fileDisabled;
      !!documentConfirmationFile2 &&
        (documentConfirmation2.setDefaultValue = [
          {
            formName: documentConfirmationFile2?.formName!,
            fileBase64: documentConfirmationFile2?.fileBase64!,
          },
        ]);
      documentConfirmationFront.showLine = false;
      documentConfirmationBack.showLine = false;
    } else {
      personalNumberVerification.showLine = false;
      documentConfirmation.showLine = false;
      documentConfirmation2.showLine = false;
      documentConfirmationFront.showLine = false;
      documentConfirmationBack.showLine = false;
    }

    newSchema = {
      ...newSchema,
      personalNumberVerification: {
        required: personalNumberVerification.showLine
          ? TkPropertyMessageGet("TKMSG_SCR0044E")
          : false,
      },
      documentConfirmation: {
        required: documentConfirmation.showLine
          ? TkPropertyMessageGet("TKMSG_SCR0044E")
          : false,
      },
      documentConfirmation2: {
        required: documentConfirmation2.showLine
          ? TkPropertyMessageGet("TKMSG_SCR0044E")
          : false,
      },
      documentConfirmationFront: {
        required: documentConfirmationFront.showLine
          ? TkPropertyMessageGet("TKMSG_SCR0044E")
          : false,
      },
      documentConfirmationBack: {
        required: documentConfirmationBack.showLine
          ? TkPropertyMessageGet("TKMSG_SCR0044E")
          : false,
      },
    } as any;
    setStateInfoList([...newStateInfoList]);
    setFormSchema(newSchema);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentSelectionValue]);

  const handleSubmit = (data: any) => {
    setInputData(data);
    if (isKiko) {
      setOpenKikoDialog(true);
    } else {
      setOpenNormalDialog(true);
    }
  };

  const handleUpdate = async () => {
    setOpenNormalDialog(false);
    setOpenKikoDialog(false);
    let fileList = [
      {
        serialNo: 1,
        staffNo: location.state?.staffNo,
        formKbn: "6",
        formClass: "27",
        fileName: inputData.personalNumberVerification[0].formName,
        fileBase64: inputData.personalNumberVerification[0].fileBase64,
      },
    ];
    if (inputData.documentSelection === "1") {
      fileList.push({
        serialNo: fileList.length + 1,
        staffNo: location.state?.staffNo,
        formKbn: "6",
        formClass: "23",
        fileName: inputData.documentConfirmation[0].formName,
        fileBase64: inputData.documentConfirmation[0].fileBase64,
      });
    } else if (
      inputData.documentSelection === "2" ||
      inputData.documentSelection === "4"
    ) {
      fileList.push(
        {
          serialNo: fileList.length + 1,
          staffNo: location.state?.staffNo,
          formKbn: "6",
          formClass: "24",
          fileName: inputData.documentConfirmationFront[0].formName,
          fileBase64: inputData.documentConfirmationFront[0].fileBase64,
        },
        {
          serialNo: fileList.length + 2,
          staffNo: location.state?.staffNo,
          formKbn: "6",
          formClass: "25",
          fileName: inputData.documentConfirmationBack[0].formName,
          fileBase64: inputData.documentConfirmationBack[0].fileBase64,
        }
      );
    } else {
      fileList.push(
        {
          serialNo: fileList.length + 1,
          staffNo: location.state?.staffNo,
          formKbn: "6",
          formClass: "23",
          fileName: inputData.documentConfirmation[0].formName,
          fileBase64: inputData.documentConfirmation[0].fileBase64,
        },
        {
          serialNo: fileList.length + 2,
          staffNo: location.state?.staffNo,
          formKbn: "6",
          formClass: "23",
          fileName: inputData.documentConfirmation2[0].formName,
          fileBase64: inputData.documentConfirmation2[0].fileBase64,
        }
      );
    }
    try {
      const res = await httpAPI_INQ005({
        applyId: locationState?.applyId,
        contractorNo: contractorNo,
        staffNo: location.state?.staffNo,
        corpName: inputData?.contractorName,
        facilityName: inputData?.facilityName,
        staffName: inputData?.staffName,
        staffBirthday: inputData?.staffBirthday,
        formClass: inputData?.documentSelection,
        formList: fileList,
        screenId: "SCRC070206",
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        return;
      }
    } catch (error) {
      navigate("/error");
    }
  };

  return (
    <Box data-testid="SCRC070206test" className="SCRC070206">
      <TkStrpper steps={stepperData} activeStep={activeStep} />
      <TkFakeTable
        list={stateInfoList}
        ruleSchema={formSchema}
        buttonGroup={!isTaiSyokuSha && <TkBackButton />}
        submitButtonGroup={
          isKiko
            ? [
                {
                  submitButtonText: "申請",
                  showButton:
                    latestApplyStatus === "00" || latestApplyStatus === "16",
                },
              ]
            : [
                {
                  submitButtonText: "機構へ提出する",
                  showButton:
                    latestApplyStatus === "00" || latestApplyStatus === "16",
                },
              ]
        }
        onCheckAndSubmit={(data) => handleSubmit(data)}
      />
      <Box className="bottomTable">
        {(latestApplyStatus === "11" || latestApplyStatus === "13") && (
          <TkFakeTable
            list={showTableList}
            showButton={false}
            ruleSchema={{}}
          />
        )}
      </Box>
      <TkDateDialog
        open={openKikoDialog}
        title="確認（申請を行います）"
        contextText="　申請を行いますが、問題ないでしょうか。"
        minDate={new Date("1900/01/01")}
        maxDate={new Date()}
        onCancel={() => setOpenKikoDialog(false)}
        okText="はい"
        cancelText="いいえ"
        onOky={handleUpdate}
      />
      <TkDialog
        open={openNormalDialog}
        title="確認（機構へ提出します）"
        contextText="　機構へ提出を行いますが、問題ないでしょうか。"
        onCancel={() => setOpenNormalDialog(false)}
        okText="はい"
        cancelText="いいえ"
        onSave={handleUpdate}
      />
    </Box>
  );
};

export default SCRC070206;
